export const PRODUCT_NAME = 'Seaa'
export const PRODUCT_NAME_AR = 'سِعَة'
export const PRODUCT_TITLE_AR = `${PRODUCT_NAME_AR} · إدارة الحجوزات والخدمات والمواعيد`
export const PRODUCT_DOMAIN = 'seaa.app'
export function contactFormHref(locale: string) {
  return `/?lang=${encodeURIComponent(locale)}&contact=1#contact`
}

export function localizedProductName(locale: string) {
  return locale === 'ar' ? PRODUCT_NAME_AR : PRODUCT_NAME
}
